module.exports = __webpack_public_path__ + "img/NZA Annex I - CO2 transport & storage.pdf";